import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  showHighwayRegistrationFlow: false,
};

export const showHighwayRegistrationFlowSlice = createSlice({
  name: 'showHighwayRegistrationFlow',
  initialState,
  reducers: {
    setShowHighwayRegistrationFlow: (state, action: PayloadAction<boolean>) => {
      state.showHighwayRegistrationFlow = action.payload;
    },
  },
});

export const { setShowHighwayRegistrationFlow } =
  showHighwayRegistrationFlowSlice.actions;
